var AbstractViewModel = require("./AbstractViewModel")
var AbstractWS = require("../ws/AbstractWS")
var QueueModel = require("../models/QueueModel")

function ForecastOverrideViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's observable-bound variables
  AbstractViewModel.apply(this, arguments);

  self.queue = ko.observable(null);
  self.forecast = ko.observable(0);


	/**
	 * Decrements the resourceCount by 5
	 *
	 * @method decrementCount
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return {Boolean} true
	 */
  self.decrementCount = function (data, evt) {
    var delta = 0;
    var newCount = self.forecast() - 1;

    newCount = Number(newCount);
    delta = newCount % 5;

    if (delta === 0) {
      delta = 5;
    }

    newCount -= delta;

    if (newCount < 1) {
      newCount = 1;
    }

    self.forecast(newCount);
  };


	/**
	 * Increments the resourceCount by 5 or to the next nearest multiple of 5
	 *
	 * @method incrementCount
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return {Boolean} true
	 */
  self.incrementCount = function (data, evt) {
    var newCount = self.forecast() + 1;

    if (newCount < 1) {
      newCount = 1;
    }
    else if (newCount > 999) {
      newCount = 999;
    }
    else {
      newCount = Number(newCount);
      newCount = newCount + (5 - (newCount % 5));
    }

    self.forecast(newCount);
  };


	/**
	 * Returns the VM to it's default state
	 *
	 * @method reset
	 * @return none
	 */
  self.reset = function () {
    self.queue(null);
    self.forecast(0);
  };


	/**
	 * Pushes the new resource count to the API service for the current queue
	 *
	 * @method updateResourceCount
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return none
	 */
  self.updateForecastOverride = function (data, evt) {
    var queue = self.queue();

    if (queue && !self.parent.hasAntiRole('forecastOverride')) {
      var ws = new AbstractWS(self);

      ws.method('POST');
      ws.name = 'ForecastOverrideUpdater';
      ws.serviceURL = ko.computed(function () {

        return '/qless/api/v1/employee/queue/' + queue.id + '/nextForecast';
      });
      ws.addParam('forecast', self.forecast());
      ws.addParam('forecastUnits', 'MINUTES');

      ws.processData = function (data) {
        // Call the superclass method to perform any core actions
        AbstractWS.prototype.processData.call(ws, data);

        // Get the updated forecast for the queues
        self.parent.queues().forEach(function (q) {
          q.getNextWaitForecast();
        });

        self.reset();
      }

      ws.doRequest();

      self.parent.toggleForecastOverride();
    }
    else {
      self.conlog('No queue. Can\'t update');
    }
  };


	/**
	 * Ensures only numbers are entered into the resource count input
	 *
	 * @method validateInput
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return none
	 */
  self.validateInput = function (data, evt) {
    if (!self.parent.isNumericInput(evt)) {
      evt.preventDefault();
      return false;
    }

    return true;
  };


	/**
	 * Watches for the queue change and updates the resourceCount observable
	 *
	 * @method queue.subscribe
	 * @param {QueueModel} data
	 * @return none
	 */
  self.queue.subscribe(function (data) {
    if (data && data instanceof QueueModel) {
      if (data.nextWaitDuration()) {
        self.forecast(Number(data.nextWaitDuration()));
      }
    }
  });


  // Expose the object as it's own API
  return self;
};

ForecastOverrideViewModel.prototype = AbstractViewModel.prototype;
ForecastOverrideViewModel.prototype.constructor = ForecastOverrideViewModel;

module.exports = ForecastOverrideViewModel
